module.exports = __webpack_public_path__ + "img/permanent.4219ff47.png";